





import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
import {ResourceLoader} from "../n-maps/utils/ResourceLoader";

import SDK from '../../src/lib/sdk'

@Component({
  name: 'VisTimeline',
  components: {},
})
// https://visjs.github.io/vis-timeline/docs/timeline/
export default class App extends Vue {
  @Prop() public serial: any
  @Prop() public dates: any

  public initialized = false

  private offsetz: Number = 0

  created() {
    this.offsetz = -(new Date()).getTimezoneOffset()
  }

  mounted() {
    Promise.all([
      ResourceLoader("css", "vis-timeline", "https://unpkg.com/vis-timeline@7.3.7/dist/vis-timeline-graph2d.min.css"),
      ResourceLoader("script", "vis-timeline", "https://unpkg.com/vis-timeline/standalone/umd/vis-timeline-graph2d.min.js"),
    ]).then(() => {
      this.initialized = true
    })
  }

  uniformDate(date: string) {
    // @ts-ignore
    return vis.moment(date).utc().add(this.offsetz, "minutes")
  }

  @Watch('dates')
  init(x: any) {
    if (this.initialized && x.length == 2) {
      SDK.logs(this.serial, x[0], x[1]).then((d) => {
        // DOM element where the Timeline will be attached
        var container = this.$el

        // Create a DataSet (allows two way data-binding)
        // @ts-ignore
        //var items2 = new vis.DataSet([
        //  {id: 1, content: 'item 1', start: '2013-04-20 03:00:01'},
        //  {id: 2, content: 'item 2', start: '2013-04-14'},
        //  {id: 3, content: 'item 3', start: '2013-04-18'},
        //  {id: 4, content: 'item 4', start: '2013-04-16', end: '2013-04-19'},
        //  {id: 5, content: 'item 5', start: '2013-04-25'},
        //  {id: 6, content: 'item 6', start: '2020-04-27'}
        //]);

        var items: any = []
        var groups: any = [
          "CONNECTION",
          "LOGIN",
          "PING",
        ]

        d.data.forEach((i) => {
          let gName = i.human_event

          if (i.human_event) {
            if (!groups.includes(gName)) {
              groups.push(gName)
            }

            items.push({
              id: items.length,
              oid: i.id,
              content: i.event,
              start: i.start ? this.uniformDate(i.start) : null,
              end: i.end ? this.uniformDate(i.end) : null,
              packet: i.packet,
              group: gName,
              type: i.event === "CONNECTION" ? "range" : null,
              className: i.priority != "0" ? "vis-red" : null
            })
          } else if (i.event == "CONNECTION") {
            items.push({
              id: items.length,
              content: "CONNECTION",
              start: i.start ? this.uniformDate(i.start) : null,
              end: i.end ? this.uniformDate(i.end) : null,
              group: "CONNECTION",
              type: "range",
            })
          }
        })

        // Configuration for the Timeline
        var options = {
          type: 'point',
          //height: 800,
          template: (i: any) => {
            if (i.content == "CONNECTION") {
              return i.content
            }
            return ""
          },
          stack: false,
          align: 'center',
          margin: {
            item: 25,
            axis: 12,
          },
          //showCurrentTime: false,
          //moment: function (date) {
          //  //@ts-ignore
          //  return vis.moment(date).utcOffset('+02:00')
          //},
          groupOrder: function (item: any, item2: any) {
            if (item.id == "CONNECTION") {
              return -1
            }
            if (item2.id == "CONNECTION") {
              return 1
            }
            if (item.id == "LOGIN") {
              return -1
            }
            if (item2.id == "LOGIN") {
              return 1
            }


            return 0;
          }
        };

        let c: any = 0
        groups = groups.map((gName: any) => {
          return {
            content: gName,
            id: gName,
            value: c++
          }
        })

        // Create a Timeline
        // @ts-ignore
        var timeline = new vis.Timeline(container, items, options)
        timeline.setGroups(groups)
        timeline.on('click', (s: any) => { // select was double firing items[s.items[0]
          if (items[s.item]) {
            //alert(JSON.stringify(items[s.item], null, 2))
            this.$emit('cliccky', items[s.item])
          }
        });
        timeline.on('mouseOver', (s: any) => {
          if (s.item) {
            //console.log(items[s.item])
            this.$emit('hover', items[s.item])
          }
        });
        // timeline.setCustomTimeMarker('RILASCIO FW v4', "MAN", true);
      })
    }
  }
}
